import { useI18n } from "vue-i18n";

export function useRouteLocalization() {
  const { locale } = useI18n();

  /**
   * Funció que genera el nom de la ruta amb el sufix correcte segons l'idioma
   * @param {string} baseName - Nom base de la ruta sense el sufix d'idioma
   * @returns {string} Nom complet de la ruta amb el sufix d'idioma
   */
  const localizedRouteName = (baseName) => {
    return baseName + (locale.value === "en" ? "EN" : "ES");
  };

  return {
    localizedRouteName,
  };
}
